import { IconLocation, Text } from 'braid-design-system';

interface Props {
  homeLocation?: string | null;
}

export const Location = ({ homeLocation }: Props) => {
  if (!homeLocation) {
    return null;
  }

  return (
    <Text
      icon={
        <IconLocation tone="secondary" data={{ testid: 'location-icon' }} />
      }
      size="small"
    >
      {homeLocation}
    </Text>
  );
};
